import type { Field, Layout } from '../../types';

/**
 * Compliance datapoints captured upstream in TXM.
 */
export const COMPLIANCE_UPSTREAM_FIELD_NAMES: readonly string[] = [
  'property.yearBuilt',
  'property.isTenantOccupied',
  'property.hasHOA',
  'property.hasPool',
  'property.hasSepticTank',
  'property.hasWell',
  'property.hasSolar',
  'property.hasPropane',
  'isPersonalDeal',
  'acceptanceDate',
];

const yesNoOptions = [
  { label: 'Yes', value: 'true' },
  { label: 'No', value: 'false' },
];

function propertyToggleField(name: string, label: string): Field {
  return {
    name: `property.${name}`,
    entity: 'property',
    type: 'iconButtonGroup',
    label,
    options: yesNoOptions,
  };
}

export const yearBuiltField: Field = {
  name: 'property.yearBuilt',
  entity: 'property',
  type: 'year',
  label: 'Year Built',
  placeholderText: 'YYYY',
};

export const compliancePropertyToggleFields: Record<string, Field> = {
  isTenantOccupied: propertyToggleField('isTenantOccupied', 'Tenant Occupied'),
  hasHOA: propertyToggleField('hasHOA', 'HOA'),
  hasPool: propertyToggleField('hasPool', 'Pool'),
  hasSepticTank: propertyToggleField('hasSepticTank', 'Septic Tank'),
  hasWell: propertyToggleField('hasWell', 'Well'),
  hasSolar: propertyToggleField('hasSolar', 'Solar'),
  hasPropane: propertyToggleField('hasPropane', 'Propane'),
};

const propertyToggleLayout = (name: string, xl: number): Layout => ({
  name: `property.${name}`,
  size: 25,
  mobileSize: 50,
  tabletSize: 25,
  xl,
});

export const compliancePropertyTogglesLayoutRow: Layout[] = [
  propertyToggleLayout('isTenantOccupied', 14),
  propertyToggleLayout('hasHOA', 14),
  propertyToggleLayout('hasPool', 14),
  propertyToggleLayout('hasSepticTank', 14),
  propertyToggleLayout('hasWell', 14),
  propertyToggleLayout('hasSolar', 14),
  propertyToggleLayout('hasPropane', 16),
];

export const personalDealField: Field = {
  name: 'isPersonalDeal',
  entity: 'interaction',
  type: 'iconButtonGroup',
  label: 'Personal Deal',
  options: yesNoOptions,
};

export const acceptanceDateField: Field = {
  name: 'acceptanceDate',
  entity: 'interaction',
  type: 'date',
  label: 'Offer Accepted Date',
  placeholderText: '',
};
